import React, { useEffect, useMemo, useState } from 'react';
import { useParams } from 'react-router-dom';
import DashboardLayout from '../../components/layout/DashboardLayout';
import chauffeurService from '../../services/chauffeurService';
import transporteurService from '../../services/transporteurService';
import ChauffeurProfileView from '../../components/transporteur/ChauffeurProfileView';
import { deleteChauffeurDocument } from '../../services/chauffeurService';
import { useI18n } from '../../i18n/I18nContext';

export default function ChauffeurDetails() {
  const { t } = useI18n();
  const { id } = useParams();
  const [driver, setDriver] = useState(null);
  const [incidents, setIncidents] = useState([]);
  const [missions, setMissions] = useState([]);
  const [documents, setDocuments] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    (async () => {
      try {
        setLoading(true);
        const d = await chauffeurService.getDriverById(id);
        setDriver(d);
        try {
          const inc = await transporteurService.getIncidents();
          setIncidents((inc || []).filter(x => String(x.chauffeurId) === String(id)));
        } catch (_) { }
        try {
          const m = await chauffeurService.getChauffeurMissions(id);
          setMissions(m || []);
        } catch (_) { }
        try {
          const docs = await chauffeurService.getDriverDocuments(id);
          setDocuments(docs || []);
        } catch (_) { }
      } catch (e) {
        setError(e?.message || t('chauffeurs.profile.failedToLoad'));
      } finally {
        setLoading(false);
      }
    })();
  }, [id, t]);

  const handleToggleActive = async (nextActive) => {
    if (!driver) return;
    try {
      setSaving(true);
      await chauffeurService.setDriverActive(driver.id, nextActive);
      setDriver(prev => prev ? { ...prev, active: nextActive, disponible: nextActive ? prev.disponible : false } : prev);
      setError(null);
    } catch (e) {
      setError(e?.message || t('chauffeurs.profile.failedToUpdate'));
    } finally {
      setSaving(false);
    }
  };

  const handleDeleteDocument = async (documentId) => {
    if (!id) return;
    try {
      await deleteChauffeurDocument(documentId);
      const docs = await chauffeurService.getDriverDocuments(id);
      setDocuments(docs || []);
    } catch (e) {
      setError(e?.message || t('chauffeurs.profile.failedToDeleteDoc'));
    }
  };

  if (loading) {
    return (
      <DashboardLayout>
        <div className="container mt-4 d-flex justify-content-center">
          <div className="spinner-border" role="status"><span className="visually-hidden">{t('common.loading')}</span></div>
        </div>
      </DashboardLayout>
    );
  }

  if (error) {
    return (
      <DashboardLayout>
        <div className="container mt-4">
          <div className="alert alert-danger">{error}</div>
        </div>
      </DashboardLayout>
    );
  }

  if (!driver) return null;

  return (
    <DashboardLayout>
      <ChauffeurProfileView
        driver={driver}
        missions={missions}
        incidents={incidents}
        documents={documents}
        onToggleActive={handleToggleActive}
        toggling={saving}
        onDeleteDocument={handleDeleteDocument}
      />
    </DashboardLayout>
  );
}
